/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { RenArt, RenArtInterface } from "../RenArt";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "publicStage",
            type: "bool",
          },
          {
            internalType: "uint8",
            name: "stageId",
            type: "uint8",
          },
          {
            internalType: "uint16",
            name: "maxSupply",
            type: "uint16",
          },
          {
            internalType: "uint32",
            name: "startTime",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "endTime",
            type: "uint32",
          },
          {
            internalType: "uint160",
            name: "mintPrice",
            type: "uint160",
          },
        ],
        internalType: "struct RenArt.StageInfo",
        name: "_initStageInfo",
        type: "tuple",
      },
      {
        internalType: "string",
        name: "_initBaseURI",
        type: "string",
      },
      {
        internalType: "address[]",
        name: "payees",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "shares",
        type: "uint256[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "ERC20PaymentReleased",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shares",
        type: "uint256",
      },
    ],
    name: "PayeeAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "PaymentReceived",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "PaymentReleased",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nextOwnerToExplicitlySet",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "publicStage",
            type: "bool",
          },
          {
            internalType: "uint8",
            name: "stageId",
            type: "uint8",
          },
          {
            internalType: "uint16",
            name: "maxSupply",
            type: "uint16",
          },
          {
            internalType: "uint32",
            name: "startTime",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "endTime",
            type: "uint32",
          },
          {
            internalType: "uint160",
            name: "mintPrice",
            type: "uint160",
          },
        ],
        internalType: "struct RenArt.StageInfo",
        name: "_stageInfo",
        type: "tuple",
      },
    ],
    name: "nextStage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "payee",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "amount",
        type: "uint8",
      },
    ],
    name: "publicMint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "account",
        type: "address",
      },
    ],
    name: "release",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "release",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "released",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "released",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "reserve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "baseURI",
        type: "string",
      },
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "shares",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "stageInfo",
    outputs: [
      {
        internalType: "bool",
        name: "publicStage",
        type: "bool",
      },
      {
        internalType: "uint8",
        name: "stageId",
        type: "uint8",
      },
      {
        internalType: "uint16",
        name: "maxSupply",
        type: "uint16",
      },
      {
        internalType: "uint32",
        name: "startTime",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "endTime",
        type: "uint32",
      },
      {
        internalType: "uint160",
        name: "mintPrice",
        type: "uint160",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
    ],
    name: "totalReleased",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalReleased",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalShares",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "whitelistInfo",
    outputs: [
      {
        internalType: "uint8",
        name: "nonce",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "stageId",
        type: "uint8",
      },
      {
        internalType: "uint240",
        name: "remain",
        type: "uint240",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "redeemer",
            type: "address",
          },
          {
            internalType: "uint8",
            name: "stageId",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "amount",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "nonce",
            type: "uint8",
          },
          {
            internalType: "uint72",
            name: "price",
            type: "uint72",
          },
        ],
        internalType: "struct RenArt.NFTVoucher",
        name: "voucher",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
      {
        internalType: "uint8",
        name: "amount",
        type: "uint8",
      },
    ],
    name: "whitelistMint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

export class RenArt__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    _initStageInfo: {
      publicStage: boolean;
      stageId: BigNumberish;
      maxSupply: BigNumberish;
      startTime: BigNumberish;
      endTime: BigNumberish;
      mintPrice: BigNumberish;
    },
    _initBaseURI: string,
    payees: string[],
    shares: BigNumberish[],
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<RenArt> {
    return super.deploy(
      _initStageInfo,
      _initBaseURI,
      payees,
      shares,
      overrides || {}
    ) as Promise<RenArt>;
  }
  getDeployTransaction(
    _initStageInfo: {
      publicStage: boolean;
      stageId: BigNumberish;
      maxSupply: BigNumberish;
      startTime: BigNumberish;
      endTime: BigNumberish;
      mintPrice: BigNumberish;
    },
    _initBaseURI: string,
    payees: string[],
    shares: BigNumberish[],
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _initStageInfo,
      _initBaseURI,
      payees,
      shares,
      overrides || {}
    );
  }
  attach(address: string): RenArt {
    return super.attach(address) as RenArt;
  }
  connect(signer: Signer): RenArt__factory {
    return super.connect(signer) as RenArt__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): RenArtInterface {
    return new utils.Interface(_abi) as RenArtInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): RenArt {
    return new Contract(address, _abi, signerOrProvider) as RenArt;
  }
}
